import { render, staticRenderFns } from "./especializacoesEditar.vue?vue&type=template&id=13ee1313&scoped=true&"
import script from "./especializacoesEditar.vue?vue&type=script&lang=js&"
export * from "./especializacoesEditar.vue?vue&type=script&lang=js&"
import style0 from "./especializacoesEditar.vue?vue&type=style&index=0&id=13ee1313&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee1313",
  null
  
)

export default component.exports